/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{isSphericalECEF as e}from"../../geometry/ellipsoidUtils.js";import{WGS84ECEFSpatialReference as r,getSphericalPCPF as t}from"../../geometry/spatialReferenceEllipsoidUtils.js";import{isEarth as o,isWGS84 as i,isWebMercator as s,isCGCS2000 as p}from"../../geometry/support/spatialReferenceUtils.js";function l(l){return o(l)?i(l)||s(l)||p(l)||e(l)?r:l:t(l)}export{l as computeEuclideanMeasurementSR};
